import { useCallback, useMemo } from "react";
import {
  useGetMeQuery,
  useGetUserPermissionsQuery,
} from "../../infrastructure/api/ProfileApi";
import type { UserProfile } from "../../domain/entities/Profile";

type ApiError = { data?: { message?: string } };

export const useProfile = () => {
  const {
    data: meData = null,
    isLoading: meLoading,
    error: meError,
    refetch: refetchMe,
  } = useGetMeQuery();

  const userId = meData?.id;

  const {
    data: permissionsData,
    isLoading: permissionsLoading,
    error: permissionsError,
  } = useGetUserPermissionsQuery(userId!, { skip: !userId });

  const profile = useMemo((): UserProfile | null => {
    if (!meData) return null;
    return {
      ...meData,
      roleName: permissionsData?.roleName ?? meData.roleName,
      permissions: permissionsData?.permissionGroups ?? [],
    };
  }, [meData, permissionsData?.roleName, permissionsData?.permissionGroups]);

  const loading = meLoading || permissionsLoading;

  const error = meError
    ? ((meError as ApiError).data?.message ?? "Failed to load profile.")
    : permissionsError
      ? ((permissionsError as ApiError).data?.message ??
        "Failed to load permissions.")
      : null;

  const fetchProfile = useCallback(async (): Promise<UserProfile | null> => {
    const result = await refetchMe();
    return result.data ?? null;
  }, [refetchMe]);

  const updateUserProfile = useCallback(
    async (): Promise<boolean> => {
      return false;
    },
    [],
  );

  return {
    profile,
    loading,
    error,
    fetchProfile,
    updateProfile: updateUserProfile,
  };
};

export type ProfileData = UserProfile;
